export function setCommitmentData(state, data) {
  const newState = { 
    ...state,
    commitment: {
      ...state.commitment,
      data: data
    }
  };
  return newState
}

export function setCommitmentStatus(state, status) {
  return {
    ...state,
    commitment: {
      ...state.commitment,
      status: status
    }
  };
}